import { render, staticRenderFns } from "./CreatePublicCouncilBanner.vue?vue&type=template&id=f9d25814&scoped=true&"
import script from "./CreatePublicCouncilBanner.vue?vue&type=script&lang=js&"
export * from "./CreatePublicCouncilBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreatePublicCouncilBanner.vue?vue&type=style&index=0&id=f9d25814&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d25814",
  null
  
)

export default component.exports